// Bulle « voir » qui suit le curseur et halo des cartes produit (maquette « 30 sept », demandé au
// RDV du 30/09 : « le petit rond qui suit le curseur, comme sur les autres blocs ») :
// - une seule bulle `position: fixed`, créée au premier survol d'une zone `[data-anima-curseur]`
//   (fermes, catalogue, rail des entreprises, grilles des fiches), libellé = valeur de l'attribut ;
// - halo radial sous la souris sur les cartes produit (`--mx` / `--my`, components/_cartes.scss) ;
// - seulement avec une souris (`hover: hover` et `pointer: fine`) ; déplacement en transform,
//   un rAF par image au plus. Le curseur natif n'est masqué que sur les zones qui portent aussi
//   `data-anima-curseur-cache` (fermes et catalogue, comme la maquette).

const FINE_POINTER = '(hover: hover) and (pointer: fine)'

const init = () => {
  if (!window.matchMedia(FINE_POINTER).matches) {
    return
  }
  let bubble = null
  let x = 0
  let y = 0
  let card = null
  let frame = 0

  const render = () => {
    frame = 0
    if (bubble) {
      bubble.style.transform = `translate3d(${x}px, ${y}px, 0)`
    }
    if (card) {
      const r = card.getBoundingClientRect()
      card.style.setProperty('--mx', `${x - r.left}px`)
      card.style.setProperty('--my', `${y - r.top}px`)
    }
  }
  const schedule = () => {
    if (!frame) {
      frame = requestAnimationFrame(render)
    }
  }

  document.addEventListener('pointermove', (e) => {
    if (e.pointerType !== 'mouse') {
      return
    }
    x = e.clientX
    y = e.clientY
    const zone = e.target.closest('[data-anima-curseur]')
    card = e.target.closest('.anima-pcard')
    if (zone) {
      if (!bubble) {
        bubble = document.createElement('div')
        bubble.className = 'anima-curseur-bulle'
        bubble.setAttribute('aria-hidden', 'true')
        document.body.appendChild(bubble)
      }
      bubble.textContent = zone.dataset.animaCurseur || 'voir'
      bubble.classList.add('is-on')
    } else if (bubble) {
      bubble.classList.remove('is-on')
    }
    if (zone || card) {
      schedule()
    }
  }, {
    passive: true
  })

  document.addEventListener('pointerleave', () => {
    if (bubble) {
      bubble.classList.remove('is-on')
    }
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
